$('.testimonial-section .testimonial-wrapper').owlCarousel({
    items: 1,
    nav: false,
    dots: true,
    loop: false,
    autoplayHoverPause: true,
    autoplay: true,
    responsive: {
        0: {
            items: 1
        },
        544: {
            items: 1
        },
        768: {
            items: 1
        },
        992: {
            items: 1
        },
        1200: {
            items: 1
        }
    }
});